import { JourneyRoute } from '@cash-web/shared-journey-util-main'

// Individual route exports - import any of these independently
export const activityConfirmationFlowRoute = {
  id: 'journey-activity-confirmation-flow',
  trackingName: 'Journey Activity Confirmation Flow',
  path: 'dl/view/activity/confirmation/:transaction_id',
  lazy: async () => ({
    Component: (await import('../components/JourneyActivityConfirmationFlow')).JourneyActivityConfirmationFlow,
  }),
} as const

export const activityTokenCategoryRoute = {
  id: 'journey-activity-token-category',
  trackingName: 'Journey Activity Category',
  path: 'dl/view/activity/:activityType',
  lazy: async () => ({
    Component: (await import('../components/JourneyActivityTokenSubCategory')).JourneyActivityTokenSubCategory,
  }),
} as const

export const activityTokenSubCategoryRoute = {
  id: 'journey-activity-token-sub-category',
  trackingName: 'Journey Activity Sub Category',
  path: 'dl/view/activity/:activityType/:subToken',
  lazy: async () => ({
    Component: (await import('../components/JourneyActivityTokenSubCategory')).JourneyActivityTokenSubCategory,
  }),
} as const

export const activityItemRoute = {
  id: 'journey-activity-item',
  trackingName: 'Journey Activity Item',
  path: 'dl/view/activity/item/:activityType/:itemToken',
  lazy: async () => ({
    Component: (await import('../components/JourneyActivityItem')).JourneyActivityItem,
  }),
  modalVariant: 'receipt',
} as const

export const activityNotSupportedRoute = {
  id: 'journey-activity-not-supported',
  trackingName: 'Journey Activity Not Supported',
  path: 'dl/view/activity/not-supported',
  lazy: async () => ({
    Component: (await import('../components/JourneyActivityUnsupportedOpenMobileApp'))
      .JourneyActivityUnsupportedOpenMobileApp,
  }),
} as const

export const moneybotChatRoute = {
  id: 'journey-moneybot-chat',
  trackingName: 'Journey Moneybot Chat',
  path: 'dl/view/moneybot/chat',
  lazy: async () => ({
    Component: (await import('../components/JourneyMoneybotChat')).JourneyMoneybotChat,
  }),
} as const

export const activityReceiptV2Route = {
  id: 'journey-activity-receipt-v2',
  trackingName: 'Journey Activity Receipt V2',
  path: 'dl/view/activity/receipt-v2/:encodedProto',
  lazy: async () => ({
    Component: (await import('../components/JourneyActivityReceiptV2')).JourneyActivityReceiptV2,
  }),
  modalVariant: 'receipt',
  target: 'modal',
} as const

// Convenience export - array of all activity routes
export const activityJourneyRoutes = [
  activityConfirmationFlowRoute,
  activityTokenCategoryRoute,
  activityTokenSubCategoryRoute,
  activityItemRoute,
  activityNotSupportedRoute,
  moneybotChatRoute,
  activityReceiptV2Route,
] as const satisfies JourneyRoute[]
